import React, { useContext, useEffect, useRef, useState } from 'react'
import { Holistic, POSE_CONNECTIONS, FACEMESH_TESSELATION, HAND_CONNECTIONS } from '@mediapipe/holistic/holistic';
import {drawConnectors, drawLandmarks } from '@mediapipe/drawing_utils/drawing_utils';

const MediapipeHolisticProviderContext = React.createContext();
export function useMediapipeHolisticProvider() {
    return useContext(MediapipeHolisticProviderContext)
}

export function MediapipeHolisticProvider({ children }) {

    const mediapipeHolisticModelRef = useRef(undefined);
    const [statusMediapipeHolistic, setStatusMediapipeHolistic] = useState(false);
    const statusMediapipeHolisticRef = useRef(statusMediapipeHolistic);

    const [configMediapipeHolisticModel, setConfigMediapipeHolisticModel] = useState(0);
    const [configMediapipeHolisticSmoothLandmarks, setConfigMediapipeHolisticSmoothLandmarks] = useState(true);
    const [configMediapipeHolisticDetectionConfidence, setConfigMediapipeHolisticDetectionConfidence] = useState(0.5);
    const [configMediapipeHolisticTrackingConfidence, setConfigMediapipeHolisticTrackingConfidence] = useState(0.5);

    const mediapipeHolisticResultsRef = useRef(null);
    const mediapipeHolisticDataBufferRef = useRef([]);
    const mediapipeHolisticDataBufferIsRecordingRef = useRef(false)

    const mediapieHolistic_num_elements = useRef(53);

    const idx_kps_pose = [0, 2, 5, 7, 8, 11, 12, 13, 14, 15, 16];
    const remove_visibility_idx_kps_pose = [18, 20, 22, 17, 19, 21];


    useEffect(() => {
        console.log("🚀 ~ MediapipeHolisticProvider ~ statusMediapipeHolistic:", statusMediapipeHolistic)
        if (statusMediapipeHolistic){
            initializeMediapipeHolistic();
            statusMediapipeHolisticRef.current = true;
        }
        else{
            mediapipeHolisticModelRef.current = undefined;
            statusMediapipeHolisticRef.current = false;
        }
    }, [statusMediapipeHolistic])

    const initializeMediapipeHolistic = async () => {
        console.log("🚀 ~ MediapipeHolisticProvider ~ initializeMediapipeHolistic:")

        mediapipeHolisticModelRef.current = new Holistic({locateFile: (file) => {
            return `https://cdn.jsdelivr.net/npm/@mediapipe/holistic/${file}`;
        }});
        mediapipeHolisticModelRef.current.onResults(onResultsMediapipeHolistic);
        mediapipeHolisticModelRef.current.setOptions({
            modelComplexity: configMediapipeHolisticModel,
            smoothLandmarks: configMediapipeHolisticSmoothLandmarks,
            minDetectionConfidence: configMediapipeHolisticDetectionConfidence,
            minTrackingConfidence: configMediapipeHolisticTrackingConfidence,
            enableSegmentation: true,
            smoothSegmentation: false,
        });

        console.log("🚀 ~ MediapipeHolisticProvider ~ initializeMediapipeHolistic:    OK")
        statusMediapipeHolisticRef.current = true;
    };

    function clearMediapipeHolisticDataBuffer(){
        console.log("🚀 ~ clearMediapipeHolisticDataBuffer ~ clearMediapipeHolisticDataBuffer:", clearMediapipeHolisticDataBuffer)
        mediapipeHolisticDataBufferRef.current = []
    }

    function startMediapipeHolisticDataBufferRecord(){
        mediapipeHolisticDataBufferIsRecordingRef.current = true;
    }

    function stopMediapipeHolisticDataBufferRecord(){
        mediapipeHolisticDataBufferIsRecordingRef.current = false;
    }

    function getMediapipeHolisticDataBuffer(){
        return mediapipeHolisticDataBufferRef.current;
    }

    function onResultsMediapipeHolistic(results) {
        // console.log("🚀 ~ MediapipeHolisticProvider ~ onResultsMediapipeHolistic:", onResultsMediapipeHolistic)
        mediapipeHolisticResultsRef.current = results;
        // console.log("🚀 ~ onResultsMediapipeHolistic ~ results:", results)

        // if (configMediapipeHolisticRecordBuffer && results.poseLandmarks) {
        //     // Inicialización eficiente de kps_frame para evitar referencias duplicadas
        //     const kps_frame = Array.from({ length: mediapieHolistic_num_elements.current }, () => [0,0,0,0]);
        //     // Asignación de datos de pose
        //     idx_kps_pose.forEach((idx_mediapipe, idx) => {
        //         kps_frame[idx] = [
        //             results.poseLandmarks[idx_mediapipe].x,
        //             results.poseLandmarks[idx_mediapipe].y,
        //             results.poseLandmarks[idx_mediapipe].z,
        //             results.poseLandmarks[idx_mediapipe].visibility
        //         ];
        //     });
        //     // Función para asignar landmarks de las manos al kps_frame
        //     function assignHandLandmarks(handLandmarks, startIndex) {
        //         for (let idx = 0; idx < handLandmarks.length; idx++) {
        //             const landmark = handLandmarks[idx];
        //             kps_frame[startIndex + idx] = [landmark.x, landmark.y, landmark.z, 1];
        //         }
        //     }
        //     // Pre-calcular índices de inicio para landmarks de manos
        //     const leftHandStartIndex = idx_kps_pose.length;
        //     const rightHandStartIndex = leftHandStartIndex + 21;
        //     // Asignación de landmarks para manos izquierda y derecha
        //     const leftHandLandmarks = results.leftHandLandmarks || [];
        //     const rightHandLandmarks = results.rightHandLandmarks || [];
        //     assignHandLandmarks(leftHandLandmarks, leftHandStartIndex);
        //     assignHandLandmarks(rightHandLandmarks, rightHandStartIndex);
        //     // Agregar el frame procesado al buffer
        //     mediapipeHolisticDataBufferRef.current.push(kps_frame);
        // }


        if (results.poseLandmarks !== undefined) {
            if (mediapipeHolisticDataBufferIsRecordingRef.current){
                const kps_frame = new Array(mediapieHolistic_num_elements.current).fill([0,0,0,0]);
    
                if (results.poseLandmarks !== undefined) {
                    for (const [idx, idx_mediapipe] of idx_kps_pose.entries()) {
                        kps_frame[idx] = [results.poseLandmarks[idx_mediapipe].x, results.poseLandmarks[idx_mediapipe].y, results.poseLandmarks[idx_mediapipe].z, results.poseLandmarks[idx_mediapipe].visibility];
                    }
                }
                for (let idx = 0; idx < 21; idx++){
                    if (results.leftHandLandmarks !== undefined) {
                        kps_frame[idx+idx_kps_pose.length] = [results.leftHandLandmarks[idx].x, results.leftHandLandmarks[idx].y, results.leftHandLandmarks[idx].z, 1];
                    }
                    if (results.rightHandLandmarks !== undefined) {
                        kps_frame[idx+idx_kps_pose.length+21] = [results.rightHandLandmarks[idx].x, results.rightHandLandmarks[idx].y, results.rightHandLandmarks[idx].z, 1];
                    }
                }
                mediapipeHolisticDataBufferRef.current = [...mediapipeHolisticDataBufferRef.current,kps_frame]
                console.log("🚀 ~ clearMediapipeHolisticDataBuffer ~ clearMediapipeHolisticDataBuffer:", mediapipeHolisticDataBufferRef.current.length)
            }
        }
    }

    async function applyMediapipeHolisticOnCanvas(streamImageBitmapRef, streamCanvasRef, streamContextRef){
        if (statusMediapipeHolisticRef.current){
            streamImageBitmapRef.current = await createImageBitmap(streamCanvasRef.current);
            await mediapipeHolisticModelRef.current.send({image: streamImageBitmapRef.current});
            if (mediapipeHolisticResultsRef.current!== null) {
                if (mediapipeHolisticResultsRef.current){
                    // streamContextRef.current.fillStyle = 'black';
                    // streamContextRef.current.fillRect(0, 0, streamCanvasRef.current.width, streamCanvasRef.current.height);
                    drawConnectors(streamContextRef.current, mediapipeHolisticResultsRef.current.poseLandmarks, POSE_CONNECTIONS,{color: '#00FF00', lineWidth: 1});
                    drawLandmarks(streamContextRef.current, mediapipeHolisticResultsRef.current.poseLandmarks,{color: '#FF0000', lineWidth: 1,radius: 2});
                    drawConnectors(streamContextRef.current, mediapipeHolisticResultsRef.current.leftHandLandmarks, HAND_CONNECTIONS,{color: '#CC0000', lineWidth: 1});
                    drawLandmarks(streamContextRef.current, mediapipeHolisticResultsRef.current.leftHandLandmarks,{color: '#00FF00', lineWidth: 1,radius: 2});
                    drawConnectors(streamContextRef.current, mediapipeHolisticResultsRef.current.rightHandLandmarks, HAND_CONNECTIONS,{color: '#00CC00', lineWidth: 1});
                    drawLandmarks(streamContextRef.current, mediapipeHolisticResultsRef.current.rightHandLandmarks,{color: '#FF0000', lineWidth: 1,radius: 2});
                }
            }
        }else{
            console.log("🚀 ~ MediapipeHolisticProvider ~ applyMediapipeHolisticOnCanvas STEP EEROR  -- NO INICALIZADO:")
        }
        return Promise.resolve();
    }


    /* Exported values */
    const value = {
        statusMediapipeHolistic,
        setStatusMediapipeHolistic,
        statusMediapipeHolisticRef,
        mediapipeHolisticResultsRef,

        mediapipeHolisticDataBufferRef,
        getMediapipeHolisticDataBuffer,
        clearMediapipeHolisticDataBuffer,
        startMediapipeHolisticDataBufferRecord,
        stopMediapipeHolisticDataBufferRecord,

        applyMediapipeHolisticOnCanvas,
    }

   
    return (
        <MediapipeHolisticProviderContext.Provider value={value}>
            {children}
        </MediapipeHolisticProviderContext.Provider>
    )
}